var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.couponCodeData,"hide-default-header":_vm.$vuetify.breakpoint.xsOnly,"item-key":"id","hide-sort":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }